import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material-module/material-module';
import { FormsModule } from '@angular/forms';
import { ArticleWithGroupsModalComponent } from './article-with-groups-modal.component';
import { ArticleItemWithGroupsShowComponent } from './article-item-with-groups-show/article-item-with-groups-show.component';
import { SharedUiModule } from 'src/app/shared-ui/shared-ui.module';

@NgModule({
	imports: [CommonModule, MaterialModule, TranslateModule, FormsModule, SharedUiModule],
	declarations: [ArticleWithGroupsModalComponent, ArticleItemWithGroupsShowComponent],
	exports: [ArticleWithGroupsModalComponent, ArticleItemWithGroupsShowComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ArticleWithGroupsModalModule {}
